const _ = require('lodash');

// Clients has specific rules
const clientsAdditionalDetails = [
  {
    nationalId: 1,
    details: [
      { label: 'Proof Of Age', field: 'meta.proofOfAge' },
      { label: 'Home Club', field: 'meta.homeClub' },
      { label: 'Coaches Emails', field: 'meta.coachesEmails' },
      { label: 'Clubs', field: 'meta.clubs' },
    ]
  },
  {
    nationalId: 2,
    details: [
      { label: 'Member Classification', field: 'meta.classification' },
    ]
  },
  {
    nationalId: 3,
    details: [
    ]
  },
  {
    nationalId: 4,
    details: [
      { label: 'Has Medical', field: 'meta.medical.hasMedical' },
      { label: 'Medical Notes', field: 'meta.medical.notes' },
      { label: 'School', field: 'meta.school' },
      { label: 'Photography Opt Out', field: 'meta.photographyOptOut' },
      { label: 'USyd Staff', field: 'meta.isStaff' },
      { label: 'USyd Student', field: 'meta.isStudent' },
      { label: 'Find About Us', field: 'meta.findAboutUs' },
    ]
  },
  {
    nationalId: 5,
    details: [
    ]
  },
  {
    nationalId: 6,
    details: [
      { label: 'Weapon', field: 'meta.weapon' },
      { label: 'Hand Dominance', field: 'meta.handDominance' },
      { label: 'Home Club', field: 'meta.homeClub' },
      { label: 'Is Aboriginal', field: 'meta.isAboriginal' },
      { label: 'News Opt Out', field: 'meta.newsOptOut' },
      { label: 'Is Vaccinated', field: 'meta.vaccinated' },
      { label: 'Vaccination Shot', field: 'meta.vaccinationShot' },
    ]
  },
  {
    nationalId: 7,
    details: [
    ]
  },
  {
    nationalId: 8,
    details: [
      { label: 'Personal Number', field: 'meta.personalNumber' },
      { label: 'Place of Birth', field: 'meta.placeOfBirth' },
      { label: 'Registration Date', field: 'meta.registrationDate' },
      { label: 'Contracted', field: 'meta.contracted' },
      { label: 'Start Contract Date', field: 'meta.startContractDate' },
      { label: 'End Contract Date', field: 'meta.endContractDate' },
      { label: 'License Type', field: 'meta.licenseType' },
      { label: 'License ID', field: 'meta.licenseId' },
      { label: 'Qualification', field: 'meta.qualification' },
      { label: 'National League', field: 'meta.nationalLeague' },
      { label: 'Category', field: 'meta.category' },
      { label: 'Location', field: 'meta.location' },
      { label: 'Role', field: 'meta.refereeRoles' },
      { label: 'Original Club', field: 'meta.originalClub' },
      { label: 'Nationality', field: 'meta.nationality' },
      { label: 'Country of Birth', field: 'meta.countryOfBirth' },
    ]
  },
  {
    nationalId: 9,
    details: [

    ]
  },
  {
    nationalId: 10,
    details: [
      { label: 'Weapon', field: 'meta.weapon' },
      { label: 'Hand Dominance', field: 'meta.handDominance' },
      { label: 'Is Aboriginal', field: 'meta.isAboriginal' },
      { label: 'Is Volunteering', field: 'meta.volunteer' },
      { label: 'Volunteer Type', field: 'meta.volunteerType' }
    ]
  },
  {
    nationalId: 11,
    details: [
      { label: 'Member Type', field: 'meta.utasMemberType' },
      { label: 'Student ID', field: 'meta.utasId' },
    ]
  },
  {
    nationalId: 14,
    details: [
      { label: 'National ID', field: 'meta.nationalId' },
      { label: 'Home Club', field: 'meta.additionalEmails' },
    ]
  },
  {
    nationalId: 15,
    details: [
      { label: 'Bow Type', field: 'meta.bowType' },
      { label: 'Home Club', field: 'meta.homeClub' },
      { label: 'Club Code', field: 'meta.clubCode' },
      { label: 'Other Clubs', field: 'meta.otherClubs' },
      { label: 'Interest', field: 'meta.interestsOne' },
      { label: 'Aboriginal', field: 'meta.isAboriginal' },
    ]
  },
];

module.exports = {
  clientsAdditionalDetails,
};
